import { useState } from 'react'
import { Form, Input, Button, notification } from 'antd'
import { createOrg, updateOrg } from "../../../api/organization";


export default function OrgUpsert({
    initialValues,
    onComplete
}: {
    initialValues?: Partial<Orgnization>;
    onComplete: () => void;
}) {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);
    const isEdit = !!initialValues?.organizationId;

    return (
        <Form form={form} initialValues={{
            ...initialValues,
        }} {
            ...{
                labelCol: { span: 4 },
                wrapperCol: { span: 20 },
            }
            }>
            <Form.Item name='name' label='名称' rules={[{ required: true }]}>
                <Input />
            </Form.Item>
            <Form.Item name='province' label='所在省份' rules={[{ required: true }]}>
                <Input />
            </Form.Item>
            <Form.Item name='city' label='所在城市' rules={[{ required: true }]}>
                <Input />
            </Form.Item>
            <Form.Item name='description' label='备注信息'>
                <Input.TextArea placeholder='请输入备注信息' />
            </Form.Item>
            <div style={{ textAlign: 'center' }}>
                <Button loading={submitting} onClick={async () => {
                    let values;
                    try {
                        values = await form.validateFields();
                    } catch (err) {
                        console.error(err)
                    }
                    if (!values) return;
                    const payload = {
                        ...initialValues,
                        ...values,
                    };
                    setSubmitting(true);
                    try {
                        if (isEdit) {
                            await updateOrg(initialValues.organizationId!, payload)
                        } else {
                            await createOrg(payload)
                        }
                        notification.success({ message: isEdit ? '更新成功' : '创建成功' })
                        onComplete()
                    } catch (err) {
                        notification.error({ message: isEdit ? '更新失败, 请重试' : '创建失败, 请重试' })
                    }
                    setSubmitting(false);
                }
                } type='primary'>确认</Button>
            </div>
        </Form >
    )
}